export default {
  event: {},
  guest: {},
};
